// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fel1","title":"styles_title__Smd2k"};